<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Assunto</h3>
      </div>
    </div>
    <AssuntoAdd v-if="showAdd" ref="AssuntoAdd" v-on:Back="onBack" />
    <AssuntoList v-else ref="AssuntoList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import AssuntoAdd from './components/add/assuntoadd.vue'
import AssuntoList from './components/list/assuntolist.vue'

export default {
  name: 'Assunto',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    AssuntoAdd,
    AssuntoList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.AssuntoAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/assunto/assunto.vue